import $ from 'jquery';

function makeSlick() {

	$( '.cta-mobile' ).slick( {
		dots: false,
		infinite: false,
		slidesToShow: 1,
		centerMode: false,
		speed: 300,
		variableWidth: true,
		arrows: false,
		responsive: [ {
			breakpoint: 3000,
			settings: "unslick"
		}, {
			breakpoint: 1024,
			settings: {
				variableWidth: true,
			}
		}, {
			breakpoint: 640,
			settings: {
				variableWidth: false,
			}
		} ]
	} );

	$( '.featured-categories-block__categories' ).slick( {
		dots: false,
		infinite: false,
		slidesToShow: 4.25,
		slidesToScroll: 4,
		centerMode: false,
		speed: 300,
		variableWidth: false,
		arrows: true,
		transformEnabled: false,
		prevArrow: $('.slick-prev-cat'),
		nextArrow: $('.slick-next-cat'),
		responsive: [ {
			breakpoint: 1024,
			settings: {
				slidesToShow: 3.3333,
				slidesToScroll: 3,
			},
		}, {
			breakpoint: 640,
			settings: {
				slidesToShow: 2.33333333,
				slidesToScroll: 2,
			},
		}, {
			breakpoint: 450,
			settings: {
				slidesToShow: 1.33333333,
				slidesToScroll: 1,
			},
		}]
	} );

		const $slider = $( '.featured-products-block__products' )
		const $progressBar = $( '.progress' );
		const $progressBarLabel = $( '.slider__label' );

		$slider.on('init', function (event, slick) {
			const defaultPercentage = 100 / slick.slideCount * slick.getOption( 'slidesToShow' )

			$progressBar.css( 'background-size', defaultPercentage + '% 100%' )
		})

		$slider.on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
			const defaultPercentage = 100 / slick.slideCount * slick.getOption( 'slidesToShow' )
			let calc = defaultPercentage + ( nextSlide / ( slick.slideCount - 1 ) * 100 );

			$progressBar
					.css( 'background-size', calc + '% 100%' )
					.attr( 'aria-valuenow', calc );

			$progressBarLabel.text( calc + '% completed' );
		} );

	$slider.slick( {
					infinite: false,
					slidesToScroll: 1,
					speed: 300,
					slidesToShow : 4.25,
					prevArrow: $( '.slick-prev-products-block' ),
					nextArrow: $( '.slick-next-products-block' ),
					responsive: [ {
						breakpoint: 1024,
						settings: {
							slidesToShow: 3.5
						},
					}, {
						breakpoint: 890,
						settings: {
							slidesToShow: 2.5
						},
					}, {
						breakpoint: 640,
						settings: {
							slidesToShow: 2.25
						},
					}, {
						breakpoint: 450,
						settings: {
							slidesToShow: 1.5
						},
					}, {
						breakpoint: 320,
						settings: {
							slidesToShow: 1.20
						},
					} ]
				}
		).on( 'wheel', ( function ( e ) {
			e.preventDefault();
			if ( e.originalEvent.deltaY > 0 ) {
				$( this ).slick( 'slickNext' );
			} else {
				$( this ).slick( 'slickPrev' );
			}
		} ) );

	$( '.reading-block__mobile-slider' ).slick( {
		dots: false,
		infinite: false,
		slidesToShow: 2,
		centerMode: false,
		speed: 300,
		variableWidth: true,
		arrows: false,
		responsive: [ {
			breakpoint: 3000,
			settings: "unslick"
		}, {
			breakpoint: 1024,
			settings: {
				variableWidth: false,
			},
		} , {
			breakpoint: 640,
			settings: {
				variableWidth: false,
				slidesToShow: 1
			},
		}]
	} )

	.on('setPosition', function (event, slick) {
		slick.$slides.css('height', slick.$slideTrack.height() + 'px');
		$('.story-related-card').css('height', slick.$slideTrack.height() + 'px')
	});

}

makeSlick();

let isLarge = $( window ).width() > 1024;
$( window ).resize( Foundation.util.throttle( function () {
	if ( $( window ).width() > 1024 && !isLarge ) {
		isLarge = true;
	} else if ( $( window ).width() < 1025 && isLarge ) {
		isLarge = false;
		makeSlick();
	}
}, 300 ) );